import {
  HULL_CLEANING_REQUEST_REASONS,
  HullCleaningRequestFormErrors,
  HullCleaningRequestFormValue,
  HullCleaningRequestReason,
} from "../models/hull-cleaning.models";

export const EMPTY_HULL_CLEANING_REQUEST_FORM: HullCleaningRequestFormValue = {
  imoNumber: "",
  reason: "",
  comment: "",
};

export function validateHullCleaningRequestForm(form: HullCleaningRequestFormValue): HullCleaningRequestFormErrors {
  const errors: HullCleaningRequestFormErrors = {};
  const imoNumber = form.imoNumber.trim();
  const comment = form.comment.trim();

  if (!imoNumber) errors.imoNumber = "IMO Number is required.";
  else if (!/^[0-9]{7}$/.test(imoNumber)) errors.imoNumber = "IMO Number must contain exactly seven numeric digits.";

  if (!form.reason) errors.reason = "Reason is required.";
  else if (!HULL_CLEANING_REQUEST_REASONS.includes(form.reason as HullCleaningRequestReason)) {
    errors.reason = "Select a supported reason.";
  }

  if (!comment) errors.comment = "Comment is required.";
  return errors;
}

export function normalizeHullCleaningRequestForm(form: HullCleaningRequestFormValue) {
  return {
    imoNumber: form.imoNumber.trim(),
    reason: form.reason as HullCleaningRequestReason,
    comment: form.comment.trim(),
  };
}

export function getHullCleaningRequestErrorMessage(error: unknown): string {
  if (typeof error === "object" && error !== null && "response" in error) {
    const response = (error as { response?: { data?: unknown } }).response;
    const data = response?.data;
    if (typeof data === "object" && data !== null) {
      const { message, error: apiError } = data as { message?: unknown; error?: unknown };
      const safeMessage = typeof message === "string" ? message : apiError;
      if (typeof safeMessage === "string" && safeMessage.trim()) return safeMessage;
    }
  }
  return "Unable to submit the hull cleaning request. Please try again.";
}
